export default "__VITE_ASSET__D8r9Tqav__"